import React from 'react'
import Loading from '../components/Loading'
import { useParams, Link } from 'react-router-dom'
const url = 'https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i='

const SingleCocktail = () => {
  const [bicchiere, setBicchiere] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const { id } = useParams()

  React.useEffect(() => {
    async function prova() {
      setLoading(true)
      try {
        const response = await fetch(`${url}${id}`)

        const getDrink = await response.json()

        const {
          strDrink: name,
          strDrinkThumb: image,
          strAlcoholic: info,
          strCategory: category,
          strGlass: glass,
          strInstructions: instructions,
          strIngredient1,
          strIngredient2,
          strIngredient3,
          strIngredient4,
          strIngredient5,
        } = getDrink.drinks[0]

        const istruzioni = [
          strIngredient1,
          strIngredient2,
          strIngredient3,
          strIngredient4,
          strIngredient5,
        ]

        const test = {
          name,
          image,
          info,
          category,
          glass,
          instructions,
          istruzioni,
        }

        setBicchiere(test)
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
    }

    prova()
  }, [id])

  if (loading) {
    return <Loading></Loading>
  }
  if (!bicchiere) {
    return <h2 className='section-title'>no cocktail to display</h2>
  } else {
    const { name, image, info, category, glass, instructions, istruzioni } =
      bicchiere
    return (
      <section className='section cocktail-section'>
        <Link className='btn btn-primary' to='/'>
          back home
        </Link>
        <h2 className='section-title'>{name}</h2>
        <div className='drink'>
          <img src={image} alt={name}></img>

          <div className='drink-info'>
            <p>
              <span className='drink-data'>name :</span> {name}
            </p>
            <p>
              <span className='drink-data'>category :</span> {category}
            </p>
            <p>
              <span className='drink-data'>info :</span>
              {info}
            </p>
            <p>
              <span className='drink-data'>glass :</span>
              {glass}
            </p>
            <p>
              <span className='drink-data'>instructons :</span> {instructions}
            </p>
            <p>
              <span className='drink-data'>ingredients :</span>
              {istruzioni.map((item, index) => {
                return item ? <span key={index}>{item}</span> : null
              })}
            </p>
          </div>
        </div>
      </section>
    )
  }
}

export default SingleCocktail

// strDrink -  name
// strDrinkThumb - image
// strAlcoholic - info
// strCategory - category
// strGlass -  glass
// strInstructions - instructions
// strIngredient1
// strIngredient2
// strIngredient3
// strIngredient4
// strIngredient5

// ritorna il loading se sta caricando il dati, se no <h2 className='section-title'>no cocktail to display</h2> altrimenti

//       <section className='section cocktail-section'>
//         qui va un link che romanda all ahome con classe di 'btn btn-primary' e testo 'back home'

//         <h2 className='section-title'>{name}</h2>
//         <div className='drink'>
//           <img >...</img>
//           <div className='drink-info'>
//             <p>
//               <span className='drink-data'>name :</span> qui metti nome
//             </p>
//             <p>
//               <span className='drink-data'>category :</span> categoria
//             </p>
//             <p>
//               <span className='drink-data'>info :</span>informazioni
//             </p>
//             <p>
//               <span className='drink-data'>glass :</span> bicchiere
//             </p>
//             <p>
//               <span className='drink-data'>instructons :</span> istruzioni
//             </p>
//             <p>
//               <span className='drink-data'>ingredients :</span>
// se l'item sta metti uno span con l'item altrimenti nulla
//             </p>
//           </div>
//         </div>
//       </section> */
